import { render, staticRenderFns } from "./FilterDropdownBinder.vue?vue&type=template&id=22e587e6&scoped=true"
import script from "./FilterDropdownBinder.vue?vue&type=script&lang=js"
export * from "./FilterDropdownBinder.vue?vue&type=script&lang=js"
import style0 from "./FilterDropdownBinder.vue?vue&type=style&index=0&id=22e587e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e587e6",
  null
  
)

export default component.exports